import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FilterDivider, FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';

import { useFilters } from '../FiltersState';
import { useShowWarrantyTypeFilter } from '../utils';

import { FiltersApplicant } from './FiltersApplicant';
import { FiltersBrand } from './FiltersBrand';
import { FiltersCollaborator } from './FiltersCollaborator';
import { FiltersCreatedAt } from './FiltersCreatedAt';
import { FiltersServiceType } from './FiltersServiceType';
import { FiltersSortBy } from './FiltersSortBy';
import { FiltersStep } from './FiltersStep';
import { FiltersStockLocation } from './FiltersStockLocation';
import { FiltersStore } from './FiltersStore';
import { FiltersSubLocation } from './FiltersSubLocation';
import { FiltersSupervisor } from './FiltersSupervisor';
import { FiltersTask } from './FiltersTask';
import { FiltersWarrantyType } from './FiltersWarrantyType';
import { FiltersWorkshop } from './FiltersWorkshop';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();
  const showWarrantyTypeFilter = useShowWarrantyTypeFilter();

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({ id: 'requests.filters.search.label', message: 'Search requests' })}
        placeholder={t({
          id: 'requests.filters.search.placeholder',
          message: 'Search requests...',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <FiltersApplicant />
        <FiltersStep />
        <FiltersTask />
        <FiltersServiceType />
        {showWarrantyTypeFilter && <FiltersWarrantyType />}
        <FilterDivider />
        <FiltersStore />
        <FiltersWorkshop />
        <FiltersStockLocation />
        <FiltersSupervisor />
        <FiltersCollaborator />
        <FiltersBrand />
        <FiltersSubLocation />
        <FilterDivider />
        <FiltersCreatedAt />
        <FilterDivider />
        <FiltersSortBy />
      </FiltersDrawer>
    </Stack>
  );
};
